function initContact(){
  // JavaScript to be fired on the home page
  $('.contact-form').find('input').on('focus', function () {
    // alert("test!")
    $(this).parent().parent().addClass('active');
  }).on('blur', function () {
    // alert("test!")
    var $content = $(this).val()
    if (!$content) {
      $(this).parent().parent().removeClass('active');
    }
  })
}

export default initContact



// WEBPACK FOOTER //
// ./scripts/contact.js